<template>
  <b-modal :id="modalId" size="md" no-close-on-backdrop no-close-on-esc no-fade no-stacking centered hide-footer>
    <template #modal-header>
      <div class="my-auto">
        <h2 class="font-weight-normal" data-test-hook="mobile-subscription-modal-header">
          <div>
            <i class="far fa-warning colorOrange mr-1" data-test-hook="mobile-subscription-modal-header-icon" />
            {{ $t('xYourAccountNeedsAttentionHeader') }}
          </div>
        </h2>
      </div>
      <div class="float-right">
        <b-button
          class="btn-icon-button--gray"
          variant="icon-button"
          @click="$bvModal.hide(modalId)"
          data-test-hook="x-button-feedback-modal"
        >
          <i class="fas fa-times" />
        </b-button>
      </div>
    </template>
    <div>
      <p>{{ $t('xYouHaveProductsNotIncludedInAPlan') }}</p>
      <p>{{ storeManageText }}</p>
      <div class="row mb-3">
        <a :href="storeLink" target="_blank">
          <span data-test-hook="manage-plan-text" class="ml-3">
            {{ storeLink }}
          </span>
        </a>
      </div>
    </div>
  </b-modal>
</template>
<script>
import * as Constants from '@/constants'

export default {
  props: ['modalId', 'store'],
  computed: {
    storeManageText() {
      switch (this.store) {
        case Constants.AppleSubscriptionStore:
          return this.$t('xManagePlanOnApple')
        case Constants.GoogleSubscriptionStore:
          return this.$t('xManagePlanOnGoogle')
        default:
          return ''
      }
    },
    storeLink() {
      switch (this.store) {
        case Constants.AppleSubscriptionStore:
          return Constants.AppleStoreURL
        case Constants.GoogleSubscriptionStore:
          return Constants.GoogleStoreURL
        default:
          return ''
      }
    }
  }
}
</script>
